import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { cardsClient } from "@core/clients";
import { Card } from "@core/types";
import { useConfig } from "../config";

type Config = Omit<UseQueryOptions<Card[], unknown, any, any>, "queryFn" | "queryKey">;

const useGetCardsQuery = (options: Config = {}) => {
  const config = useConfig();

  return useQuery<Card[], any>(
    ["cards"],
    async () => {
      return await cardsClient.getCards();
    },
    {
      enabled: config?.isCardsEnabled,
      ...options,
    }
  );
};

export default useGetCardsQuery;
